import isEmpty from 'lodash/isEmpty';
import { useMemo } from 'react';
import { AiOutlineClockCircle } from 'react-icons/ai';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { useDateUpdate } from 'src/utils/helper';
import styled from 'styled-components';
import Link from '../link';

export default function CardTitle({ data, className = '', eventDataLayer = {}, path = '', showPublishDate = false, isSectionLive = false, sectionLive = [] }) {
  if (isEmpty(data)) return null;

  const href = useMemo(() => {
    return `${data?.link || path}`;
  }, [data, path]);

  return (
    <CardWrapper
      className={`card-title ${className}`}
      // ! DATALAYER
      onClick={() => sendDataLayerGlobal({ ...eventDataLayer })}
    >
      <Link title={data?.title} href={href} tabIndex={-1}>
        <h3 className={`card-title ${isSectionLive ? '' : 'text-ellipsis-2'}`}>{data?.title}</h3>
        {showPublishDate && (
          <small>
            <AiOutlineClockCircle size={15} className='date-publish --icon' />
            {isSectionLive ? data?.timeline : data?.published_at && useDateUpdate(data?.published_at)}
          </small>
        )}
      </Link>
    </CardWrapper>
  );
}

const CardWrapper = styled.div`
  position: relative;
  background-color: var(--softwhite-color);
  padding: 10px;
  .card-title {
    font-size: 18pt;
    font-weight: 500;
    line-height: 1.2;
    color: var(--text-color);
    font-family: 'DBHelvethaicaXMed', sans-serif;
    letter-spacing: 0;
  }
  .date-publish {
    &.--icon {
      margin-bottom: 2px;
      margin-right: 4px;
    }
  }

  small {
    /* font-family: 'Nunito Sans', sans-serif !important; */
    text-transform: lowercase;
    font-size: 15pt;
    font-weight: 200;
    line-height: 1;

    color: #707070;
  }
  @media (max-width: 767px) {
    .card-title,
    small {
      padding-left: 25px;
    }
    .card-title {
      &:before {
        position: absolute;
        content: '';
        width: 15px;
        height: 15px;
        left: 8px;
        top: 20px;
        background: var(--primary-color);
        border-radius: 0 5px 0 5px;
      }
    }
  }
`;
